module.exports = __webpack_public_path__ + "static/media/TonoDaruma_01A.6003d2be.gif";